import { ol_style } from "@omnia/exports/openlayers"
import { Layer } from "@omnia/shared/map/layer"

export function setBaseLayerStyle(layer: Layer, fillColor?: number[]) {
    let styles = [
        new ol_style.Style({
            stroke: new ol_style.Stroke({
                color: [255, 255, 255, 1],
                width: 2,
            }),
            fill: fillColor
                ? new ol_style.Fill({
                      color: fillColor,
                  })
                : undefined,
        }),

        new ol_style.Style({
            stroke: new ol_style.Stroke({
                lineDash: [3, 3],
                color: [0, 0, 0, 1],
                width: 1,
            }),
        }),
    ]

    layer.styleProvider = (selected: boolean) => {
        return (feature, resolution) => styles
    }

    layer.refresh()
}
